<template>
    <v-radio-group :rules="rules" v-model="modelValue">
        <template v-for="(option, index) in props.options" :key="index">
            <v-radio :label="option" :value="option"></v-radio>
        </template>
    </v-radio-group>
</template>

<script setup>
import i18n from "@/i18n";
import { defineModel, defineProps } from "vue"

const modelValue = defineModel({
    type: String,
    required: true
})
const props = defineProps({
    options: {
        type: Array,
        default: () => {
            return []
        },
        required: true
    },
    required: {
        type: Boolean,
        default: () => {
            return false
        },
        required: false
    }
})
const rules = [
    (v) => {
        return !props.required || !!v || i18n.global.t("customer-info.general.rules.radio-field.valid")
    }
]
</script>

<style lang="scss" scoped></style>